import { Theme } from '@wds/styles';
import { createUseStyles } from 'react-jss';

type RuleNames =
  | 'footerContainer'
  | 'footerContent'
  | 'footerContentCell'
  | 'footerContentLogo'
  | 'footerContentText'
  | 'ctaLink';
type StyleProps = { isDarkMode: boolean };

const useStyles = createUseStyles<RuleNames, StyleProps, Theme>(theme => {
  return {
    footerContainer: {
      textAlign: 'center',
      padding: [theme?.spacing[2], theme?.spacing[4], theme?.spacing[6]],
    },
    footerContent: {
      margin: theme?.spacing[6],
    },
    footerContentCell: {
      display: 'inline-block',
      margin: [theme?.spacing[2], theme?.spacing[3]],
    },
    footerContentLogo: {
      margin: theme?.spacing[3],
      fontSize: theme?.spacing[4],
      fontWeight: theme?.type.fontWeight.regular,
    },
    footerContentText: {
      fontSize: 20,
      fontWeight: theme?.type.fontWeight.regular,
      color: ({ isDarkMode }) => (isDarkMode ? theme.palette.text.light : theme.palette.text.dark),
    },
    ctaLink: {
      padding: [10, 20],
    },
  };
});

export default useStyles;
